import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PhoneIcon from '@mui/icons-material/Phone';
import { Fab, Grid, styled, Typography } from "@mui/material";
import { ICallSign } from "utils/types";

interface IProps {
  call_sign: ICallSign,
  onCall: () => void;
  onClickPoint: () => void;
}

const Photo = styled("img")(({ theme }) => ({
  width: 50,
  height: 50,
  display: "block",
}));

export default function CallSign(props: IProps) {
  const {
    call_sign,
    onCall,
    onClickPoint,
  } = props;

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      spacing={3}
    >
      <Grid item>
        <Photo src="/logo.svg" alt="" />
      </Grid>
      <Grid item style={{
        flexGrow: 1,
        flexShrink: 1
      }}>
        <Typography>
          <b>{call_sign.driver.firstname}</b><br />
          {call_sign.car.brand}<br />
          {call_sign.car.number}
        </Typography>

      </Grid>
      <Grid item>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          wrap="nowrap"
          spacing={2}
        >
          <Grid item>
            <Fab
              color="secondary"
              size="small"
              onClick={onClickPoint}
            >
              <LocationOnOutlinedIcon />
            </Fab>
          </Grid>
          <Grid item>
            <Fab
              color="secondary"
              size="small"
              onClick={onCall}
            >
              <PhoneIcon />
            </Fab>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
